<template>
  <div class="card-view">
    <card-profile
      :id="$route.params.id"
      :profile-type="$route.query.profile"
      page
    />
  </div>
</template>

<script>
import CardProfile from '@/cards/CardProfile';

export default {
  components: {
    CardProfile,
  },
};
</script>

<style lang="scss" scoped>
.card-view {
  @include container;
  flex: 1;
}
</style>
